export function HospitalPopup({ h }) {
  return (
    <div style={{ fontFamily: "'IBM Plex Sans', sans-serif", fontSize: 12, minWidth: 200, maxWidth: 300 }}>
      <strong style={{ fontSize: 14, display: "block", marginBottom: 2, color: "#CC0000" }}>{h.name}</strong>
      {h.hospital_code && (
        <div style={{ marginBottom: 2 }}>
          <strong style={{ fontSize: 11, color: "#333" }}>Hospital Code: </strong>
          <span style={{ fontSize: 12, color: "#000", fontWeight: 700 }}>{h.hospital_code}</span>
          {h.abbreviation && <span style={{ fontSize: 11, color: "#666", marginLeft: 6 }}>({h.abbreviation})</span>}
        </div>
      )}
      {h.notification_number && (
        <div style={{ marginBottom: 2 }}>
          <strong style={{ fontSize: 11, color: "#333" }}>Notification #: </strong>
          <span style={{ fontSize: 12, color: "#000" }}>{h.notification_number}</span>
        </div>
      )}
      {h.address && (
        <div style={{ marginBottom: 2 }}>
          <strong style={{ fontSize: 11, color: "#333" }}>Address: </strong>
          <span style={{ fontSize: 12, color: "#000" }}>{h.address}</span>
        </div>
      )}
      {h.capabilities && h.capabilities.length > 0 && (
        <div style={{ marginTop: 4, paddingTop: 4, borderTop: "1px solid #DDD" }}>
          <strong style={{ fontSize: 11, color: "#333", display: "block", marginBottom: 2 }}>Categories Accepted:</strong>
          <span style={{ fontSize: 11, color: "#444" }}>{h.capabilities.join(", ")}</span>
        </div>
      )}
    </div>
  );
}
